import {useCalendarBase as $4ca33167bdccdd26$export$d652b3ea2d672d5b} from "./useCalendarBase.mjs";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $a1efc3efb5426bf7$export$3ee915f8151bd4f1(props, state) {
    return (0, $4ca33167bdccdd26$export$d652b3ea2d672d5b)(props, state);
}


export {$a1efc3efb5426bf7$export$3ee915f8151bd4f1 as useCalendar};
//# sourceMappingURL=useCalendar.mjs.map
